import React, { Component } from "react";
import { connect } from "react-redux";

//Deps
import { push } from "react-router-redux";
import { withStyles } from "@material-ui/core/styles";

function mapStateToProps(state) {
  return {
    darkMode: state.app.darkMode,
    isAuth: state.user.auth !== null,
    role: state.user.currentUser.role,

    //Form Values
    email: state.forms.profile.email,
    name: state.forms.profile.name,
    password: state.forms.profile.password,
    passwordConfirm: state.forms.profile.passwordConfirm,

    //Form State
    pending: state.forms.forms.profile.$form.pending,
    submitted: state.forms.forms.profile.$form.submitted,
    submitFailed: state.forms.forms.profile.$form.submitFailed,
    validating: state.forms.forms.profile.$form.validating,

    emailIsValid: state.forms.forms.profile.email.valid,
    formIsValid: state.forms.forms.profile.$form.valid,

    //Errors
    emailErrors: state.forms.forms.profile.email.errors,
    formErrors: state.forms.forms.profile.$form.errors
  };
}

function mapDispatchToProps(dispatch) {
  return {
    routeToProducts: () => dispatch(push("products")),
    routeToLogin: () => dispatch(push("login"))
  };
}

//Styles
const styles = theme => ({
  root: {
    flexGrow: 1,
    padding: "2em"
  }
});

class ProfilePage extends Component {
  componentWillMount() {
    this.props.routeToLogin();
  }
  render() {
    const { classes, role } = this.props;
    return <div className={classes.root}>{role} profile</div>;
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(ProfilePage));



// WEBPACK FOOTER //
// ./src/pages/ProfilePage.js